import * as React from "react";
import { Box, Paper, Typography, CircularProgress } from "@mui/material";
import TickitLogo from "../TickitLogo";
import {
  marketingFormCardSx,
  marketingFormHeaderSx,
  marketingFormTitleSx,
  marketingFormSubtitleSx,
  marketingFormBodySx,
  marketingColors,
} from "../tickitMarketingTheme";

/**
 * Request-event style form card: purple gradient header + white body.
 * Set hideHeader for embedded forms (e.g. profile tabs).
 */
export default function MarketingFormCard({
  title,
  subtitle,
  children,
  loading = false,
  hideHeader = false,
  logoHeight = 48,
  footer,
  sx = {},
}) {
  return (
    <Paper elevation={0} sx={{ ...marketingFormCardSx, ...sx }}>
      {!hideHeader && (
        <Box sx={marketingFormHeaderSx}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <TickitLogo variant="onDark" height={logoHeight} />
          </Box>
          {title && (
            <Typography component="h1" sx={marketingFormTitleSx}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography sx={marketingFormSubtitleSx}>{subtitle}</Typography>
          )}
        </Box>
      )}
      <Box sx={marketingFormBodySx}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress sx={{ color: marketingColors.p700 }} />
          </Box>
        ) : (
          children
        )}
        {footer}
      </Box>
    </Paper>
  );
}
